/**
 * Il cronometro del turno parlato: dal click di stop alla voce del tutor.
 *
 * Fra i due c'e' tutto quello di cui lo studente si lamenta ("non so quanto ci
 * mette a caricare il feedback della voce") e che finora nessuno misurava dal
 * lato del BROWSER. I log del server dicono quanto ci mette il giudizio e
 * quanto ci mette la voce, ma non dicono quanto tempo passa fra i due, ne'
 * quanto costa la chiusura della registrazione: quei pezzi vivono qui.
 *
 * Una riga per turno, sulla console:
 *
 *   KPI TURNO: stop_ms=0 finale_ms=1180 voto_ms=2530 scheda_ms=5010
 *              voce_richiesta_ms=4790 voce_parte_ms=9120
 *
 * `stop_ms=0` e' l'origine: tutte le altre tappe sono millisecondi da li'.
 * Una tappa che non e' stata raggiunta esce come `-` invece di sparire, cosi'
 * la riga si legge sempre nello stesso ordine e un buco si vede.
 *
 * NIENTE testo della risposta, del feedback o dell'utente: la riga e' fatta
 * solo dai nomi fissi delle tappe e da interi in millisecondi, e non c'e' modo
 * di infilarci altro: `segna` accetta solo i nomi di `TAPPE` e scrive solo la
 * differenza fra due `performance.now()`.
 *
 * Per questo la riga esce con un `console.log` secco, in tutti gli ambienti e
 * non solo in sviluppo: e' l'unica misura del turno che abbiamo dal lato del
 * browser, e serve leggibile quando si guarda una sessione insieme allo
 * studente o si chiede uno screenshot della console. Stessa scelta dei KPI del
 * server, che si scrivono anche in produzione.
 *
 * `voce_richiesta_ms` puo' essere MINORE di `scheda_ms`: e' il punto. Il
 * riassunto e' l'ultimo campo che il modello scrive, ma dopo di lui restano
 * il messaggio di chiusura dello stream e due giri di render prima che la
 * scheda sia "finita" per React. La voce si chiede al riassunto, non li'.
 *
 * `voce_parte_ms` e' il momento in cui la RIPRODUZIONE viene avviata: `play()`
 * che si risolve, o la sorgente WebAudio che parte. Non e' il primo suono
 * udibile: restano fuori la latenza del dispositivo audio e, sul percorso
 * progressivo, la decodifica del primo pezzo dentro l'elemento <audio>. Il
 * numero vero e' un filo piu' alto di quello che si legge qui.
 */

// L'ordine in cui le tappe escono nella riga. E' anche l'ordine in cui
// dovrebbero succedere: leggerla di fila dice dove il turno si e' seduto.
const TAPPE = ['finale', 'voto', 'scheda', 'voce_richiesta', 'voce_parte'];

let inizio = null;
let tappe = {};

const ora = () =>
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();

/**
 * Il turno comincia: lo studente ha premuto stop.
 *
 * Se un turno era rimasto aperto (voce mai partita, errore, domanda saltata)
 * lo chiude prima: una riga per turno resta vera anche quando il turno di
 * prima e' finito male, ed e' proprio il caso che si vuole vedere.
 */
export const avvia = () => {
  if (inizio !== null) chiudi();
  inizio = ora();
  tappe = {};
};

/**
 * Segna una tappa. Vale la PRIMA volta: `voto` arriva a ogni pezzo di scheda
 * che passa, e quello che conta e' quando il numero e' comparso.
 */
export const segna = (tappa) => {
  if (inizio === null) return;
  if (!TAPPE.includes(tappa)) return;
  if (tappe[tappa] !== undefined) return;
  tappe[tappa] = Math.round(ora() - inizio);
};

/** Questa tappa e' gia' stata segnata nel turno in corso? */
export const segnata = (tappa) => inizio !== null && tappe[tappa] !== undefined;

/** Scrive la riga e chiude il turno. Torna la riga (o null se non era aperto). */
export const chiudi = () => {
  if (inizio === null) return null;
  const riga =
    'KPI TURNO: stop_ms=0 ' +
    TAPPE.map((t) => `${t}_ms=${tappe[t] === undefined ? '-' : tappe[t]}`).join(' ');
  inizio = null;
  tappe = {};
  console.log(riga);
  return riga;
};

/** C'e' un turno in corso? Serve a chi puo' essere il PRIMO ad accorgersene. */
export const aperto = () => inizio !== null;

/** Solo per i test: nessun turno aperto, nessuna riga scritta. */
export const azzera = () => {
  inizio = null;
  tappe = {};
};
